<template src='./project-details.html'></template>

<script>
import Vue from 'vue'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import HighlightButton from '@/components/misc/HighlightButton.vue'
import VueMarkdown from 'vue-markdown'
import Prism from 'prismjs'
import 'prismjs/components/prism-go.min'
import { EventBus } from '@/router/bus'
import FileSaver from 'file-saver'

export default {
  components: {
    ContextPage,
    HighlightButton,
    VueMarkdown
  },
  data () {
    return {
      projectCode: this.$route.params.projectCode,
      project: {},
      pageLoader: false,
      phaseStatus: {
        ENTRY: 1,
        WAITINGCONFIRMATION: 2,
        WAITINGAPPROVAL: 3,
        APPROVED: 4
      },
      projectStatus: {
        PENDING: 0,
        FINISHED: 1
      },
      projectPhases: {
        PREIMPLEMENTATION: 0,
        IDENTIFICATION: 1
      }
    }
  },
  computed: {
    organizationName () {
      return `${this.project ? this.project.organizationId : ''} - ${this.project ? this.project.organizationName : ''}`
    }
  },
  created () {
    this.setupPage()
  },
  mounted () {
    EventBus.$emit('reload-crumbs')
  },
  methods: {
    highlight () {
      this.$nextTick(() => {
        Prism.highlightAll()
      })
    },
    setupPage () {
      this.showLoader(true)
      this.$http.get(Vue.$apiConfig.projectDetailsGet + '/' + this.$route.params.projectCode)
        .then(
          response => {
            this.project = response.data.payload
            if (!this.project.description) {
              this.project.description = this.$t('projects.emptyProjectDescription')
            }
            if (!this.project.name) {
              this.project.name = this.$t('projects.emptyProjectName')
            }
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    exportProject () {
      this.showLoader(true)
      this.$http.get(Vue.$apiConfig.generateProjectGet.replace('{projectCode}', this.$route.params.projectCode) + '?exportForms=true&exportOptions=true&exportDocuments=true', { responseType: 'blob' })
        .then(
          response => {
            const blob = new Blob([response.data], { type: 'application/zip' })
            FileSaver.saveAs(blob, this.projectCode + '.zip')
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    exportProjectIdentityCard () {
      this.showLoader(true)
      this.$http.get(Vue.$apiConfig.generateProjectIdGet.replace('{projectCode}', this.$route.params.projectCode), { responseType: 'blob' })
        .then(
          response => {
            const headers = response.headers
            const blob = new Blob([response.data], {
              type: headers.get('content-type')
            })
            FileSaver.saveAs(blob, this.projectCode + '-id.pdf')
            this.showLoader(false)
          },
          error => {
            this.formatErrorResponse(error)
            this.showLoader(false)
          }
        )
    },
    showLoader  (loader) {
      EventBus.$emit('projectLoader', loader)
    }
  }
}
</script>
<style>
.project-description {
  overflow: auto;
  height: 360px;
}
.not-defined-project-details {
  text-align: center;
  align-self: center;
  text-transform: capitalize;
}
.project-details {
  border-right-style: inset;
}
.detail-row {
  padding-bottom: 15px;
}

.project-name {
  font-size: 1.8rem
}
</style>
